module.exports = __webpack_public_path__ + "img/Ov02-PA-113659.2c9f0a10.jpg";